<template>
    <div class="login__section">
        <div class="login__heading">
            <div class="login__bg">
                <img src="/images/my-account/my-account-icon.svg" alt="" class="login__my-account-icon" />
            </div>
        </div>
        <div v-if="showForgotPassword === true">
            <div class="login__form-item">
                <h1 class="login__form-h1">Reset Password</h1>
            </div>
            <div class="login__form-item">
                <input v-model="signInForm.email" type="text" data-validate="input"
                    data-validate-message="Please enter your email" name="email"
                    autocomplete="off" class="form-element__input" placeholder="Email address*">
            </div>
            <div class="login__form-item">
                <button type="button" @click="resetPassword" class="btn btn--primary login__password-reset-button">Send password reset link</button>
            </div>
            <div class="login__form-item">
                <button type="button" @click="toggleForgotPassword" class="btn btn--fake-link login__form-forgot">Back to login</button>
            </div>
        </div>
        <div v-else>
            <div class="login__form-item">
                <h1 class="login__form-h1">Login to your account</h1>
            </div>
            <div class="login__form-item">
                <ul v-if="errors && errors.length > 0" class="validation-error__ul ul__no-bullet">
                    <li v-for="error in errors" :key="error" class="validation-error__li validation-error--danger">{{ error }}</li>
                </ul>
                <div v-if="statusMessage" class="validation-error__ul ul__no-bullet">
                    <li class="validation-error__li validation-error--success">
                        {{ statusMessage }}
                    </li>
                </div>
                <input v-model="signInForm.email" type="email" data-validate="input"
                data-validate-message="Please enter your email" name="email"
                class="form-element__input" placeholder="Email address*">
            </div>
            <div class="login__form-item">
                <div class="login__password-container">
                    <input v-model="signInForm.password" class="form-element__input" :type="passwordFieldType" name="password" id="password" placeholder="Password*">
                    <span class="login__toggle-password" @click="togglePasswordVisibility">
                        <img :src="eyeIcon" alt="Toggle Password" class="login__eye-icon" id="eye-icon">
                    </span>
                </div>
            </div>
            <div class="login__form-item">
                <button type="button" class="btn btn--primary btn--full-width" @keypress.enter="login" @click="login">
                    <span>Sign in</span>
                </button>
            </div>
            <div class="login__form-item">
                <button type="button" @click="toggleForgotPassword" class="btn btn--fake-link login__form-forgot">Forgot Password?</button>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState} from "vuex";
export default {
    components: {},
    data() {
        return {
            signInForm: {},
            showPassword: false,
            showForgotPassword: false
        };
    },

    methods:{
        toggle(){
            this.guest = !this.guest
            this.$emit('toggle-guest', this.guest);
        },
        resetPassword() {
            this.$store.dispatch('Auth/resetPassword', { email: this.signInForm.email }).then(this.showForgotPassword = false)
        },
        login() {
            this.$store.dispatch('Auth/login', { email: this.signInForm.email, password: this.signInForm.password })
        },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        },
        toggleForgotPassword(){
            this.showForgotPassword = !this.showForgotPassword;
        },
    },

    computed:{
        ...mapState("Auth", [
            'errors',
            'statusMessage'
        ]),
        hasErrors() {
            return this.errors.length > 0;
        },
        passwordFieldType() {
            return this.showPassword ? 'text' : 'password';
        },
        eyeIcon() {
            return this.showPassword ? '/images/my-account/eye-closed.svg' : '/images/my-account/eye-open.svg';
        },
    }
};
</script>
